import http from './http';

const BASE_ENDPOINT = '/api/v1/charges';

const unwrap = (axiosResponse) => {
  if (!axiosResponse) {
    return null;
  }

  if (axiosResponse?.data === undefined) {
    return axiosResponse;
  }

  return axiosResponse.data?.data ?? axiosResponse.data;
};

export const chargesService = {
  async getByDoctor(doctorId, params = {}) {
    if (!doctorId) {
      throw new Error('doctorId is required to fetch charges');
    }

    const response = await http.get(`${BASE_ENDPOINT}/doctor/${doctorId}`, { params });
    return unwrap(response);
  },

  async create(payload) {
    const response = await http.post(BASE_ENDPOINT, payload);
    return unwrap(response);
  },

  async update(chargeId, payload) {
    if (!chargeId) {
      throw new Error('chargeId is required to update charges');
    }

    const response = await http.put(`${BASE_ENDPOINT}/${chargeId}`, payload);
    return unwrap(response);
  },

  async remove(chargeId) {
    if (!chargeId) {
      throw new Error('chargeId is required to delete charges');
    }

    const response = await http.delete(`${BASE_ENDPOINT}/${chargeId}`);
    return unwrap(response);
  }
};

export default chargesService;
